/**
 * The customer portal's own origin. The public tracking page is served on another hostname
 * (track.westernalliancelogistics.com) where the portal's routes do not exist, so anything that
 * must land on the portal (Login) goes here. WEB_APP_URL is baked into index.html at build time;
 * it is empty in local dev, hence the fallback to the current origin.
 */
export const getPortalOrigin = (): string => {
    const configured = typeof window.WEB_APP_URL === 'string' ? window.WEB_APP_URL.trim().replace(/\/+$/, '') : '';

    return /^https?:\/\//.test(configured) ? configured : window.location.origin;
};
